import {useRef} from 'react'
import Text from '../../../../utils/text'
import InstructionModal from '.'
import methods from '../../../../data/methods.json'
import {CopyIcon, InstructionIcon, LinkIcon} from '../../../../icons'
import './index.scss'
import Modal from '../../../core/modal'
import renderSkeletonLoaders from '../../../../utils/loader'
import classNames from 'classnames'
import {useSelector} from 'react-redux'
import {useNamespaceTranslations} from '../../../../utils/hooks/useNamespacesTranslations'

const UrlContainer = ({
    url,
    data,
    urlType,
    options,
    method,
    className = null,
    isLoading = false,
    instructionModal,
    setInstructionModal,
    showSeeInstructionsBtn = true,
    urlBoxClassName = ''
}) => {
    const inputRef = useRef()
    const text = useNamespaceTranslations('instructions')
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    const toggleInstructionModal = () => {
        setInstructionModal(!instructionModal)
    }

    const copyToClipboard = () => {
        Text.copyText(inputRef.current.value)
    }

    return (
        <div className={classNames('url-section', {
            dark: isDarkMode,
            [urlBoxClassName]: !!urlBoxClassName
        })}>
            <Modal isOpen={instructionModal}
                contentClassName="instruction-modal overflow-auto"
                title={text.instructions}
                closeModal={toggleInstructionModal}>
                <InstructionModal url={url} data={data} urlType={urlType} options={options} textTitle={options?.title} className={className}/>
            </Modal>
            <h3 className='url-section-title'>
                {options?.urlContainerTitle || text.make_request_title.replace(':methods', methods.find(item => item.value === method)?.value)}
            </h3>
            <div className='url-section-input-wrapper'>
                <div className='url-section-input-container'>
                    <div>
                        {isLoading ? renderSkeletonLoaders(1, 'text-skeleton') :
                            <>
                                {options?.icon || <LinkIcon/>}
                                <input
                                    ref={inputRef}
                                    type='text'
                                    value={url}
                                    disabled={true}
                                />
                            </>
                        }
                    </div>
                    <button
                        onClick={copyToClipboard}
                        className={classNames('url-section-copy-clipboard', {
                            disabled: isLoading
                        })}
                        disabled={isLoading}>
                        <CopyIcon/>
                        {text.copy_clipboard}
                    </button>
                </div>
                {showSeeInstructionsBtn && <button  className={classNames('url-section-see-instructions', {
                    disabled: isLoading
                })} onClick={toggleInstructionModal} disabled={isLoading}>
                    <InstructionIcon/>
                    {text.see_instructions}
                </button>}
            </div>

        </div>
    )
}

export default UrlContainer
